<div>
    <div>
        <h1>
            {{ localizations.aumico_users_registration_main_title | i18next }}
        </h1>
        <div
            class="paragraph"
            [innerHtml]="localizations.aumico_users_registration_sub_title | i18next | safeHtml"
        ></div>
    </div>

    <form [formGroup]="form">
        <div class="registration-fields">
            <input
                hamInput
                label="{{ 'aumico_reports_side_bar_organization_name' | i18next }}"
                placeholder="{{ 'aumico_reports_side_bar_organization_name' | i18next }}"
                [formControl]="this.form.controls['org']"
            />
            <div style="display: flex; gap: 16px">
                <input
                    hamInput
                    label="{{ 'aumico_reports_registration_welcome_first_name_label' | i18next }}"
                    placeholder="{{ 'aumico_reports_registration_welcome_first_name_label' | i18next }}"
                    [formControl]="this.form.controls['firstName']"
                />
                <input
                    hamInput
                    label="{{ 'aumico_reports_registration_welcome_last_name_label' | i18next }}"
                    placeholder="{{ 'aumico_reports_registration_welcome_last_name_label' | i18next }}"
                    [formControl]="this.form.controls['lastName']"
                />
            </div>
            <input
                hamInput
                label="{{ localizations.aumico_reports_reset_password_forgot_email_username | i18next }}"
                placeholder="{{ localizations.aumico_users_registration_email_username_placeholder | i18next }}"
                [formControl]="this.form.controls['email']"
            />

            <div class="country-row">
                <input
                    hamSimpleDropDown
                    label=" {{ 'aumico_users_registration_country_label' | i18next }}"
                    [options]="countries"
                    returnKey="id"
                    [returnObject]="true"
                    [optionKeys]="['name']"
                    [multiple]="false"
                    placeholder="{{ 'aumico_users_registration_country_placeholder' | i18next }}"
                    [formControl]="this.form.controls['country']"
                />
            </div>
        </div>

        <div class="terms-conditions">
            <aumico-policy-and-subscription-controls
                [form]="form"
                [localizations]="localizations"
                (pricesClicked)="openPricesLink()"
                (privacyPolicyClicked)="openPrivacyPolicyLink()"
                (termsAndConditionsClicked)="openTermsAndConditionsLink()"
                (agreementOnOrderDataProcessingClicked)="openAgreementOnOrderDataProcessingLink()"
            ></aumico-policy-and-subscription-controls>
        </div>
    </form>
</div>
